import { F0Form } from '@factorialco/f0-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useForm } from './form'

export const NewTagForm = () => {
  const { company } = useCurrentSession()
  const { formDefinition, formRef } = useForm({ companyId: company.id })

  return <F0Form formDefinition={formDefinition} formRef={formRef} />
}
